import { ChangeDetectionStrategy, Component, computed, inject, input, output } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { MatIconModule } from '@angular/material/icon';
import { TranslocoDirective } from '@jsverse/transloco';
import { BaseModalComponent } from '../base-modal/base-modal/base-modal.component';

@Component({
  selector: 'ld-google-maps-modal',
  imports: [BaseModalComponent, MatIconModule, TranslocoDirective],
  templateUrl: './google-maps-modal.component.html',
  styleUrl: './google-maps-modal.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GoogleMapsModalComponent {
  private readonly sanitizer = inject(DomSanitizer);

  readonly address = input.required<string>();

  readonly close = output<void>();

  readonly mapUrl = computed<SafeResourceUrl>(() => {
    const query = encodeURIComponent(this.address());
    const url = `https://www.google.com/maps?q=${query}&output=embed`;
    return this.sanitizer.bypassSecurityTrustResourceUrl(url);
  });

  protected onClose(): void {
    this.close.emit();
  }

  protected onBackdropClick(event: MouseEvent): void {
    if (event.target === event.currentTarget) {
      this.onClose();
    }
  }
}
